import React from 'react';
import { getLiftClass, getLiftColor, getLiftStatusColors } from "../../helpers/map";
import LiftLabelTypeSeat from "./components/LiftLabelTypeSeat";
import LiftLine from "./components/LiftLine";

const Lift2R = ({ isOpen, state, activeLiftId }) => {
	const colors = getLiftColor(isOpen, state);
	return (
		<g id="Lift2R"
			 className={getLiftClass(isOpen, activeLiftId === '2R', state)}
			 transform="translate(1030.000000, 715.000000)"
		>
			<LiftLine x1="13.75" y1="13.75" x2="180.889513" y2="89.9792091" color={colors[0]}/>

			<LiftLabelTypeSeat
				seatCount="4"
				colors={getLiftStatusColors(state, isOpen)}
				isOpen={isOpen}
				coords="65.000000, 32.000000"/>

			<LiftLine x1="188.5" y1="93.5" x2="414.5" y2="196.5" color={colors[0]}/>

			<g id="Labe-lift">
				<circle fill={colors[1]} cx="13" cy="13" r="13"/>
				<circle fill="#FFFFFF" cx="13" cy="13" r="10"/>
				<g strokeWidth="1" transform="translate(5.000000, 4.000000)"
					 fill={colors[2]} fontFamily="OpenSans-Bold, Open Sans" fontSize="12"
					 fontWeight="bold">
					<text>
						<tspan x="0.114257812" y="13">2R</tspan>
					</text>
				</g>
			</g>

			<g id="Labe-lift" transform="translate(405.000000, 185.000000)">
				<circle fill={colors[1]} cx="13" cy="13" r="13"/>
				<circle fill="#FFFFFF" cx="13" cy="13" r="10"/>
			</g>

			<polygon
				fill={colors[1]}
				transform="translate(417.500000, 197.500000) scale(-1, 1) rotate(-216.000000) translate(-417.500000, -197.500000) "
				points="412 197.5 423 192 420.628513 197.5 423 203"/>
		</g>
	);
};

Lift2R.propTypes = {};

export default Lift2R;
